import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { ExpenseReportDetailComponent } from './expense-report-detail/expense-report-detail.component';
import { ExpenseReportOverviewComponent } from './expense-report-overview/expense-report-overview.component';
import { ExpenseReportLineDialogComponent } from './expense-report-line-dialog/expense-report-dialog.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'sales-reporting/expenses',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    {
                        path: 'overview',
                        component: ExpenseReportOverviewComponent,
                        data: { title: 'Expense Reports' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    { path: 'overview/:id', component: ExpenseReportDetailComponent, data: { title: 'Expense Report Detail' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],

    declarations: [ExpenseReportOverviewComponent, ExpenseReportDetailComponent, ExpenseReportLineDialogComponent],
})
export class ExpenseReportsModule {}